var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUndoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 7C0.834375 7 0.5 6.66563 0.5 6.25V1.75C0.5 1.33437 0.834375 1 1.25 1C1.66562 1 2 1.33437 2 1.75V4.25313L2.625 3.51875C3.90625 1.98125 5.84062 1 8 1C11.8656 1 15 4.13438 15 8C15 11.8656 11.8656 15 8 15C6.425 15 4.96875 14.4781 3.8 13.6C3.46875 13.35 3.40313 12.8813 3.65 12.55C3.89688 12.2188 4.36875 12.1531 4.7 12.4C5.61875 13.0906 6.75938 13.5 8 13.5C11.0375 13.5 13.5 11.0375 13.5 8C13.5 4.9625 11.0375 2.5 8 2.5C6.30312 2.5 4.78438 3.26875 3.775 4.48125L3.77187 4.4875L2.90937 5.5H5.75C6.16563 5.5 6.5 5.83437 6.5 6.25C6.5 6.66563 6.16563 7 5.75 7H1.25Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUndoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "0450a2954ff353fcd21be88c21b35430.svg";